import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path
      fillRule="evenodd"
      d="M14.45 3.534a.75.75 0 0 1-.03.783 4.565 4.565 0 0 0 6.33 6.33.75.75 0 0 1 1.166.655 7.837 7.837 0 0 1-7.485 7.509 3.42 3.42 0 0 1-3.09 1.939h-6.35c-1.5 0-2.741-1.2-2.741-2.706 0-1.097.657-2.03 1.592-2.458a4.27 4.27 0 0 1 2.57-3.016 7.837 7.837 0 0 1 7.355-9.419.75.75 0 0 1 .684.383m-6.572 8.72.177-.004c1.448 0 2.732.703 3.515 1.785 1.73.113 3.124 1.505 3.178 3.249a6.34 6.34 0 0 0 5.473-4.71 6.065 6.065 0 0 1-7.728-7.728 6.34 6.34 0 0 0-4.615 7.408M5.256 16.22c.142-1.376 1.331-2.471 2.8-2.471 1.058 0 1.975.57 2.455 1.407a.75.75 0 0 0 .7.375q.064-.005.13-.005c1.067 0 1.909.846 1.909 1.862 0 1.015-.842 1.861-1.909 1.861h-6.35c-.698 0-1.241-.553-1.241-1.206 0-.556.39-1.037.938-1.17a.75.75 0 0 0 .568-.652"
      clipRule="evenodd"
    />
  </>
);

const Weather33 = Icon('weather-33', svgContents);

export default Weather33;
